module.exports = __webpack_public_path__ + "img/TSY_02_04.f41767c4.png";